import { secureRoute } from '@uag/react-core';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import { WallFormingRoutes, WallFormingBaseRoute } from 'app/modules/Routes';
import { CataloguePage } from 'app/modules/wallforming/CataloguePage';
import { FrustumViewerPage } from 'app/modules/wallforming/components/frustum-viewer/FrustumViewerPage';
import { NotFound } from 'app/NotFound';
import { Unauthorized } from 'app/Unauthorized';

const isE2EAuthBypassEnabled = import.meta.env.VITE_E2E_AUTH_BYPASS === 'true';

const WallFormingRoutesComponent = isE2EAuthBypassEnabled ? WallFormingRoutes : secureRoute(WallFormingRoutes);
const CataloguePageComponent = isE2EAuthBypassEnabled ? CataloguePage : secureRoute(CataloguePage);
const FrustumViewerPageComponent = isE2EAuthBypassEnabled ? FrustumViewerPage : secureRoute(FrustumViewerPage);

// Wall forming is the only application, so the root opens it directly (query params such as `host` are preserved)
const RedirectToWallForming = () => {
    const { search, hash } = useLocation();
    return <Navigate to={{ pathname: `/${WallFormingBaseRoute}`, search, hash }} replace />;
};

export const AppRoutes = () => {
    return (
        <Routes>
            <Route element={<RedirectToWallForming />} path="" />
            <Route Component={Unauthorized} path="/unauthorized" />
            <Route Component={CataloguePageComponent} path="/catalogue" />
            <Route Component={CataloguePageComponent} path="/catalog" />
            <Route Component={WallFormingRoutesComponent} path={`/${WallFormingBaseRoute}/*`} />
            <Route Component={FrustumViewerPageComponent} path="/frustum-viewer" />
            <Route Component={NotFound} path="*" />
        </Routes>
    );
};
